import type {MetadataJson} from 'libphonenumber-js/core';
import {validatePhoneNumberLength} from 'libphonenumber-js/core';

const MAX_LENGTH = 17;

/**
 * Источник - https://github.com/taiga-family/maskito/blob/main/projects/phone/src/lib/masks/phone/utils/cut-phone-by-valid-length.ts
 */
export function cutPhoneByValidLength({
    phone,
    metadata,
}: {
    phone: string;
    metadata: MetadataJson;
}): string {
    const validationResult = validatePhoneNumberLength(phone, metadata);

    if (validationResult === 'TOO_LONG') {
        return cutPhoneByValidLength({
            phone: phone.slice(0, phone.length - 1),
            metadata,
        });
    }

    if (validationResult === 'INVALID_COUNTRY' && phone.length > MAX_LENGTH) {
        return phone.slice(0, MAX_LENGTH);
    }

    return phone;
}
